import Magnifier from "./Magnifier";
import withMediaQueries from "../../hocs/withMediaQueries";

export default withMediaQueries(Magnifier);
